import React from 'react';
import PropTypes from 'prop-types';

export default class AnswerCheckbox extends React.Component {
  constructor(props) {
    super(props);

    this.readInput = this.readInput.bind(this);
  }

  readInput = (event) => {
    const { answerHandler, inputValue } = this.props;
    const selectedOptions = inputValue;

    if (event.target.checked) {
      selectedOptions.push(event.target.value);
    } else {
      const index = selectedOptions.indexOf(event.target.value);
      selectedOptions.splice(index, 1);
    }

    answerHandler(selectedOptions);
  };

  render() {
    const {
      answerValues,
      inputValue,
    } = this.props;

    return (
      <div className="adventcount-modal-checkbox">
      {answerValues.map((answer, index) => (
           <div className="adventcount-modal-checkbox-answer" key={`answer-checkbox-${index + 1}`}>
             <label key={answer} htmlFor={`answer-checkbox-${index}`}>
               <input
                 id={`answer-checkbox-${index}`}
                 type="checkbox"
                 value={index}
                 name="answer"
                 checked={inputValue.findIndex((value) => (parseInt(value, 10) === index)) !== -1}
                 onChange={this.readInput}
               />
               {answer}
             </label>
           </div>
      ))}
      </div>
    );
  }
}

AnswerCheckbox.propTypes = {
  answerHandler: PropTypes.func.isRequired,
  answerValues: PropTypes.arrayOf(PropTypes.string).isRequired,
  inputValue: PropTypes.arrayOf(PropTypes.string).isRequired,
};
